var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.221558,
    width: 35,
    height: 40,
    fill: "url(#pattern0_1_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_57",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_57",
    transform: "matrix(0.0114286 0 0 0.01 -0.0714286 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_57",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAABA1JREFUeAHtnb+O00AQhw8hCiQq6IATPQVPQMkr0FLSUvIESFQUcF6IRANNlAlHQ0lLmQegoEaiRAihrIMW+cTGiRM7+yfrnZmdk05O4l1n5vslvvhzkjs5kR8hIASEgBAQAkJACAgBIcCfgJlWp/y7JNShBvV3CepTPVMPjDGXCJXOs9QalGl/q68aqicGqms8uyXQVRtGG4wG9XMFarKEN3cJtMCrxH2B2Nua3ZkG9Xk1Vw8NwGVenSPtxsI/tFyB+lbP1FPz8ewG0lZ4lHUoiO56DdUfDer98oO6x4MAsi66wD2vL1bz6pGZTK4ga4tuOZ4BbLwia18ELGfV93qunht4fYsuCSSVHyMQuw0NZ8saFDTHNEjao1eGhZlgudCgHht4cZUelYwVJwhia7emZ9WPi93Z+dmdjG3SuevUgdjti6JxfExYYOMuRdH0xjNuEO0rs+Z+RdHsiSVnIPa+RdFsBGOhYFmuFQ28vb5RZjkXsQTRraNYRdMFgfR6OYoGaQBbxzK2xiIUjW2W0pK1oqEURE+tvBRNT5N7dxmYx7JRNJghh9RGXtGENE1nDkFFQwfutnbxqZuUovFpjPpYEoqGOuTQ+tEqmtCGuMxDp2i4gD1SH/kVzZEaIXfcMtR3VkUzVFjp67IomtKhe/Q/jqJp3q+rZ+pdDWqhZ9VvjwJZ7aZc+/6vaJ6Z85e3RzlrZqavbjZvdGs+J9J8JKEG9UWD+uVacCnjsisaCWrIFCBSNBJUGxRqRVNyUCQUjf0DWFpQaBWNDaRvyT0odIqmL4hDtzMNKr+iOQTedz2HoLIqGl/goeMpBrVWNFDdD+0b7TwJJFM0FMF3LQbJXRYH8N0gGm+I/tPLTMGvBSzal73cwXefDWgODEsDvxlEVnVSMvjNEJrLo8pFAd9a3W4QNSTU7wJ+CHy7LtkJKjmF20LefeTvrkt+CtelCBlzEcxIb3LY+s7F3UdEyWGsHdOYX6ZTMvC+3rMqjb6iCr09v9IoFDxepVFqIGiURteWlxRIVqXRBd93vYRARlUafaBdb+cdSEKl4QrYdxy3QJIpDV+woeO5BCJfHIDnCH8cpRH6iPedR/EZkkVp+IINHU8pkKxKIxSw7zwigeRXGr5gQ8djDQTtuzRCQbvOwxYIWqXhCjR2HIZASCiNWNCu83MGQkppuAKNHZcnEIJKIxa06/yxAiGvNFyBxo5LHQgbpREL2nV+wkB4KQ1XoLHjjhkIa6URC9p1/jECKUJpuAKNHRcZSDlKIxa063zfQIpVGq5AY8e5BrJWGvKvV2ORD88fCkSUxjC7JGv3BSJKIwlqt41uByJKw41awlGiNBLCDdm0mVanIfNkjhAQAkJACAgBISAEhIAQEAJCIJDAP3u4B58lLjo/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendInput);
export default __webpack_public_path__ + "static/media/sendInput.1fb24b83fe9a468bd062c805401f606c.svg";
export { ForwardRef as ReactComponent };